import React from 'react';

const Intestazione = ({ intestazione }) => {
  return (
    <div className='grey lighten-4'>
      <h1>{intestazione}</h1>
    </div>
  );
};
export default Intestazione;



// WEBPACK FOOTER //
// ./src/components/common/IntestazioneParagrafo.js